import React from 'react';
import ShopImageUploader from './ShopImageUploader';

interface LogoUploaderProps {
  shopId: string;
  logoUrl: string;
  placeholderUrl?: string;
  uploadUrl?: string;
  invalidateQueryKey?: import('@tanstack/react-query').QueryKey;
  onUploaded?: (url: string) => void;
}

const LogoUploader: React.FC<LogoUploaderProps> = ({
  shopId,
  logoUrl,
  placeholderUrl = 'https://placehold.co/100x100?text=Logo',
  uploadUrl,
  invalidateQueryKey,
  onUploaded,
}) => {
  return (
    <ShopImageUploader
      shopId={shopId}
      imageType="logo"
      title="Logo"
      initialUrl={logoUrl}
      placeholderUrl={placeholderUrl}
      buttonLabel="Change Logo"
      containerStyle={{ width: 120, height: 120, borderRadius: 12 }}
      imageStyle={{ borderRadius: 12 }}
      uploadUrl={uploadUrl}
      invalidateQueryKey={invalidateQueryKey}
      onUploaded={onUploaded}
    />
  );
};

export default LogoUploader;
